/* eslint-disable */
import React from "react";
import "./styles.scss";

const ModalComponent = ({ children, open, position, onClick }) => {
  return (
    <div
      className={`modal-component ${open && "show"} ${position}`}
      onClick={onClick}
    >
      {children}
    </div>
  );
};
export default ModalComponent;
